import React from 'react'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { IMG_BASE_URL } from '../../../../config/Config'

const Kundli_Main_Banner = ({ banner }) => {
  return (
    <div>
          <div className="gi-breadcrumb mb-[15px]">
        <div className="flex flex-wrap justify-between items-center">
            <div className="flex flex-wrap w-full">
                <div className="w-full px-[12px]">
                    <div className="flex flex-wrap m-0">
                        <div className="w-full">
                            <img src={`${IMG_BASE_URL}${banner?.banner}`} className="w-full rounded" alt={banner?.alt} />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Kundli_Main_Banner